import { render, staticRenderFns } from "./ResponseHandling.vue?vue&type=template&id=587e8655&"
import script from "./ResponseHandling.vue?vue&type=script&lang=ts&"
export * from "./ResponseHandling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports